import { Star } from 'lucide-react'
import { Testimonial } from '../data/testimonials'

interface TestimonialCardProps {
  testimonial: Testimonial
}

const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
  return (
    <div className="card p-6 h-full flex flex-col">
      {/* Rating */}
      <div className="flex items-center space-x-1 mb-4">
        {[...Array(5)].map((_, index) => (
          <Star
            key={index}
            className={`h-5 w-5 ${
              index < testimonial.rating
                ? 'text-yellow-500 fill-current'
                : 'text-gray-300'
            }`}
          />
        ))}
      </div>

      {/* Testimonial Text */}
      <p className="text-gray-700 mb-6 leading-relaxed flex-grow">
        "{testimonial.text}"
      </p>

      {/* Author Info */}
      <div className="flex items-center space-x-3 mt-auto">
        <img
          src={testimonial.image}
          alt={testimonial.name}
          className="w-12 h-12 rounded-full object-cover border-2 border-gray-100"
        />
        <div>
          <h4 className="font-semibold text-gray-900 text-sm">{testimonial.name}</h4>
          <p className="text-xs text-gray-500 font-medium">{testimonial.location}</p>
        </div>
      </div>
    </div>
  )
}

export default TestimonialCard
